import React, { useRef, useEffect, useState } from "react";
import style from "css/landing.module.css";
import Questions from "components/app/questions";
import Slogan from "components/landing/slogan";
import Project from "components/landing/project";
import Technology from "components/landing/technology";
import History from "components/landing/history";
import Partners from "components/landing/partners";
import News from "components/landing/news";
import Social from "components/landing/social";
import SEOMeta from "components/app/SEOMeta";
/**
 * 파일명: Landing.js
 * 작성자: 강연승
 * 작성일자: 25.02.06
 * 설명: Landing page
 */

function LandingMobile(props) {
  const mainRef = useRef(null);
  const sloganRef = useRef(null);
  const projectRef = useRef(null);

  const sections = [mainRef, sloganRef];

  const [sloganBoxStyle, setSloganBoxStyle] = useState({
    scale: 0,
    opacity: 0,
  });

  const [isOneScroll, setIsOneScroll] = useState(true);
  // 도형 스케일 다 커졌는지 상태 추가
  const [canScrollNext, setCanScrollNext] = useState(false);

  const textColor = sloganBoxStyle.scale >= 0.9 ? "#000" : "#fff";

  const scaleRef = useRef(sloganBoxStyle.scale);

  // Ref에 최신 상태 저장
  const canScrollNextRef = useRef(canScrollNext);
  const isOneScrollRef = useRef(isOneScroll);

  const handleClick = () => {
    projectRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <SEOMeta
        title="리브테크놀로지, riv Technology"
        description="리브테크놀로지는 스마트워크와 원격진료 솔루션을 개발.제공하는 소프트웨어 전문 기업입니다."
        keywords="riv, riv Technology, neat, 스마트 회의실, 화상회의"
      />
      <div className={style.landing_wrap}>
        <div className={style.background}>
          <video
            src={`${process.env.REACT_APP_CLIENT_URL}video/landing.mp4`}
            autoPlay={true}
            muted={true}
            loop={true}
            controls={false}
          ></video>
        </div>
        <div className={style.background_overlay} />
        <div className={style.landing_logo_wrap}>
          <div className={style.lading_logo_text_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` + "img/landing/riv_m.png"
              }
              alt="logo"
            />
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/landing/technology_m.png"
              }
              alt="logo"
            />
          </div>
          <p className={style.landing_logo_text}>
            {"One Platform\nfor Hybrid System."}
          </p>
        </div>
        <button className={style.landing_scroll_guide_btn}>SCROLL</button>
      </div>

      <Project />
      <Technology />
      <History />
      <Partners />
      {/* <News /> */}
      <Social />
      <Questions />
    </>
  );
}

export default LandingMobile;
